import Vue from "vue";
import { Button, Col, Row, Input, Container, Pagination } from "element-ui";

Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.use(Input);
Vue.use(Container);
Vue.use(Pagination);
